import apiClient from '../../../Services/ApiClient';

export const searchPatientsByUserNumber = async (userNumber: string) => {
	const numbers = await apiClient.get(`/user/number/search/${userNumber}`);
	const patients = await apiClient.get(`/patients/search/${userNumber}`);
	return [...patients.data, ...numbers.data];
};
